export const Routes = {
  actionLists: '/action-lists',
  bankAccounts: '/bank-accounts',
  employees: '/employees',
  employeeSpecialtyTypes: '/employee-specialty-types',
  dynamicFields: '/dynamic-fields',
  fileUseTypes: '/file-use-types',
  home: '/',
  lineOfBusiness: '/line-of-business',
  marginCategory: '/margin-categories',
  netSuiteConfig: '/netsuite-accounts',
  netSuiteLog: '/netsuite',
  noAccess: '/no-access',
  commissionTables: '/commission-tables',
  peopleImport: '/people/import',
  propertiesImport: '/properties/import',
  companiesImport: '/companies/import',
  unitMixesImport: '/unit-mixes/import',
  investmentSalesImport: '/investment-sales/import',
  listingStatsImport: '/listing-stats/import',
  activeInvestmentSalesImport: '/investment-sales/active/import',
  financialsImport: '/properties/:propertyId/financials/import',
  propertySubTypes: '/property-subtypes',
  propertyTypes: '/property-types',
  activityTypes: '/activity-types',
  listingInteractionTypes: '/listing-interaction-types',
  supportTeam: '/support-team',
  clientSegmentation: '/client-segmentation',
  events: '/events',
  smp: '/smp',
  softDeletes: '/soft-deletes',
  viewApplication: (id: number | string) => `/smp/application/view/${id}`,
  applicationUsers: (id: number | string) => `/smp/application/${id}/users`,
  applicationLicenses: (id: number | string) => `/smp/application/${id}/licenses`,
  applicationChargebacks: (id: number | string) => `/smp/application/${id}/chargebacks`,

  elasticSearch: '/elastic-search',
  occupierServices: '/occupier-services',
  representedBy: '/represented-by',
  smpbundles: '/smp-bundles',
  drawsAndDeductions: '/draws-and-deductions',
  
} as const;